import { render, staticRenderFns } from "./card-box.vue?vue&type=template&id=7b0fda8b&scoped=true&"
import script from "./card-box.vue?vue&type=script&lang=ts&setup=true&"
export * from "./card-box.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./card-box.vue?vue&type=style&index=0&id=7b0fda8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0fda8b",
  null
  
)

/* custom blocks */
import block0 from "./card-box.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports